/* eslint no-unused-vars: 0 */
import React, { Component } from 'react';

import Counter from './elements/Counter';

import { PageInstructions } from '../content/StepContent';
import { StepOrder } from '../constants/Steps';
import { AdviceArea, AdviceAreaStats } from '../constants/AdviceArea';

export default class PageInstruction extends Component {
    render() {
        /* eslint eqeqeq: 0 */
        if (this.props.stepIndex == null) {
            return <div></div>;
        }

        let title = PageInstructions[this.props.stepIndex].title;
        let subtitle = PageInstructions[this.props.stepIndex].subtitle;

        if (this.props.stepIndex === StepOrder.CONTACT && this.props.adviceArea) {
            title = <span>
                Great news! We have&nbsp;
                <Counter from={ 0 } to={ AdviceAreaStats[this.props.adviceArea] } delay={ 51 } speed={ 900 }
                    className="green"/>
                &nbsp;advisers across the UK who can help with&nbsp;
                <span className="line"> { AdviceArea[this.props.adviceArea] } advice.</span>
            </span>;
            subtitle = '';
        }

        return (
            <div className="app__page-title__container">
                <div className="app__page-title">
                    { title }
                </div>
                <div className="push-down-10" dangerouslySetInnerHTML={{ __html: subtitle }}>
                </div>
            </div>
        );
    }
}

PageInstruction.propTypes = {
    stepIndex: React.PropTypes.number,

    adviceArea: React.PropTypes.number,
};



// WEBPACK FOOTER //
// ./src/components/PageInstruction.jsx